import { render, staticRenderFns } from "./ReorderParamSetting.vue?vue&type=template&id=b349b440&scoped=true"
import script from "./ReorderParamSetting.vue?vue&type=script&lang=ts"
export * from "./ReorderParamSetting.vue?vue&type=script&lang=ts"
import style0 from "./ReorderParamSetting.vue?vue&type=style&index=0&id=b349b440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b349b440",
  null
  
)

export default component.exports